export const CARD_GAP = 8;
